import UserContext from "@context/User/UserContext";
import React, { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Header from "../CompraLicencia/detalleCompra/header/Header";
import Footer from "../CompraLicencia/detalleCompra/footer/Footer";
import Body from "./body/Body";
import BodySuscripcion from "./body/BodySuscripcion";

const DetalleRenovacion = ({usuarioLogeado = {}}) => {
	

	return (
		<Row className="py-4">
			<Col className="compra-prices p-0 p-lg-5">
				<Container fluid className="detalle-compra">
					<Header />

					{/* <Body /> */}
					<BodySuscripcion usuarioLogeado={usuarioLogeado} />

					<Footer />
				</Container>
			</Col>
		</Row>
	);
};

export default DetalleRenovacion;
